export default __webpack_public_path__ + "static/social-glow-298a7b7a7b69dbf5fdcd6f90bbf27722.webp";